export function ShortenAddr(props: string): string {
  const addr: string = props;
  let address: string | null = null;
  if (addr.startsWith('0x')) {
    address = addr.substring(0, 6);
  } else {
    address = addr.substring(0, 6);
  }
  const last = addr.slice(-6);
  address = address + '....' + last;
  return address;
}

export function ShortenTxId(props: string): string {
  const txHash: string = props;
  let txId = txHash.substring(0, 5);
  const last = txHash.slice(-5);
  txId = txId + '....' + last;

  return txId;
}
export function CutStringTo0x(props: string): `0x${string}` {
  const str = props.substring(2);
  return `0x${str}`;
}
export function CutNftNumber(props: string): string {
  const temp: string = props;
  const split = temp.split('#');
  let re = '';
  for (let i = 0; i < split.length - 1; i++) {
    re += split[i];
  }
  return re;
}
